import { Component, Input, OnInit } from '@angular/core';

import { IColunaMonetario } from '../../interface/icm-monetario-generico';

@Component({
    selector: 'icm-coluna-monetario',
    templateUrl: './view/icm-coluna-monetario.component.html',
    styleUrls: ['./view/icm-coluna-monetario.component.scss'],
})
export class IcmColunaMonetarioComponent implements OnInit {
    @Input() linha;
    @Input() coluna: IColunaMonetario;
    @Input() carregando: boolean;

    monetario: number;
    corTexto: string = '#000000de';
    corDesabilitado: string = '#00000042';

    constructor() {}

    ngOnInit(): void {
        this.inicializarValores();
    }

    inicializarValores() {
        this.monetario = this.coluna.valor(this.linha);
        if (this.coluna?.cor) this.corTexto = this.coluna.cor(this.linha);
    }
}
